import { RecordDataSource } from "../../../records/grids";
import { percentageValueGetterFactory } from "../../../records/grids/cells/valueGetters";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";

import { vsObjectName as machineConfigurationTypeName } from "./machineConfigurationType";

export const vsObjectName = "machineConfigurationTypeGameConfiguration";

const url = "/api/machines/MachineConfigurationTypeGameConfiguration";

machineGameConfigurationTypeGameConfigurationConfig.$inject = [
  RecordGridViewServiceProviderName,
];
export function machineGameConfigurationTypeGameConfigurationConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    RecordGridViewServiceName,
    ColumnDefinitionServiceName,
    ServerUtilityName,
    (
      recordGridViewService: RecordGridViewService,
      columnDefinitionService: ColumnDefinitionService,
      serverUtility: ServerUtility
    ): GridConfiguration => {
      const configurationTypeGridConfiguration =
        recordGridViewService.getGridConfiguration(
          machineConfigurationTypeName
        )!;
      return {
        gridDataSource: new RecordDataSource(serverUtility, url),
        columns: [
          columnDefinitionService.getStringColDef({
            header: "Denomination",
            field: "MachineDenominationName",
          }),
          columnDefinitionService.getStringColDef({
            header: "Theme",
            field: "MachineThemeName",
          }),
          columnDefinitionService.getStringColDef({
            field: "Paylines",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MinRTPWIncrement",
            header: "Min RTP w/ Increment",
            valueGetter: percentageValueGetterFactory(),
          }),
          
          columnDefinitionService.getNumberColDef({
            field: "MaxRTPWIncrement",
            header: "Max RTP w/ Increment",
            valueGetter: percentageValueGetterFactory(),
          }),
          columnDefinitionService.getStringColDef({
            field: "Paytable",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MinBet",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MaxBet",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MachineConfigurationTypeGameConfigurationSystemRtp",
            header: "Game System RTP",
          }),
          columnDefinitionService.getNumberColDef({
            field: "ProgressiveIncrement",
            header: "Progressive Increment",
            valueGetter: percentageValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "MachineConfigurationTypeGameConfigurationTopAward",
            header: "Game Top Award (Credits)",
          }),
          /* TODO - fill in client specific game configuration fields */
          ...(configurationTypeGridConfiguration.columns ?? []),
        ],
        defaultSort: RecordGridViewService.combineSort(
          configurationTypeGridConfiguration.defaultSort,
          "Order"
        ),
        namePlural: "Game Configurations",
        nameSingular: "Game Configuration",
      };
    },
  ]);
}
